"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _antDesignVue = require("ant-design-vue");
var _lodash = require("lodash");
const REACH_BOTTOM_DISTANCE = 50;
const DEBOUNCE_WAIT_TIME = 300;
var _default = exports.default = {
  name: 'YsInfiniteSelect',
  components: {
    AntSelect: _antDesignVue.Select
  },
  props: {
    value: {
      type: [String, Number, Array, undefined],
      default: undefined
    },
    searchField: {
      type: [String, undefined],
      default: undefined
    },
    method: {
      type: Function,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    mode: {
      type: String,
      default: 'single'
    },
    events: {
      type: Object,
      default: () => ({})
    },
    getPopupContainer: {
      type: Function
    },
    pagination: {
      type: Object,
      default: () => ({
        pageNo: 1,
        pageSize: 10,
        total: 0
      })
    }
  },
  data() {
    return {
      page: Object.assign({
        pageNo: 1,
        pageSize: 10,
        total: 0
      }, this.pagination),
      searchValue: '',
      loading: false,
      finish: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      }
    },
    renderOptions() {
      if (this.$scopedSlots.default) {
        return undefined;
      }
      return this.options;
    }
  },
  methods: {
    handleDropdownVisibleChange(open) {
      if (open && (this.searchValue || !this.options.length)) {
        this.handleSearch();
      }
    },
    handleSearch: (0, _lodash.debounce)(function (value) {
      this.searchValue = value;
      this.page.pageNo = 1;
      this.finish = false;
      this.options = [];
      this.getData();
    }, DEBOUNCE_WAIT_TIME),
    handleScroll: (0, _lodash.debounce)(function (e) {
      const {
        target: {
          clientHeight,
          scrollTop,
          scrollHeight
        }
      } = e;
      const isReachBottom = clientHeight + scrollTop + REACH_BOTTOM_DISTANCE > scrollHeight;
      if (!isReachBottom) {
        return;
      }
      if (this.finish || this.loading) {
        return;
      }
      this.getData();
    }, DEBOUNCE_WAIT_TIME),
    handleChange(value) {
      if (!value) {
        this.searchValue = '';
        this.finish = false;
        this.page.pageNo = 1;
        this.options = [];
        this.getData();
      }
    },
    resetPage() {
      this.page = {
        ...this.page,
        pageNo: 1,
        total: 0
      };
      this.options = [];
      this.getData();
    },
    async getData() {
      try {
        this.loading = true;
        const page = this.page;
        const res = await this.method({
          ...page,
          [this.searchField]: this.searchValue
        });
        page.pageNo++;
        page.total = res.total;
        this.options.push(...res.records);
        this.finish = this.options.length >= page.total;
      } finally {
        this.loading = false;
      }
    }
  }
};